import { borderRadius, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

const getDimension = ($size?: number, $isCondensed?: boolean) =>
  $size ? `${$size}px` : $isCondensed ? '20px' : '48px';

const sharedSizeStyles = css<{
  $isCondensed: boolean;
  $size?: number;
}>`
  height: ${({ $size, $isCondensed }) => getDimension($size, $isCondensed)};
  width: ${({ $size, $isCondensed }) => getDimension($size, $isCondensed)};
`;

export const StyledLogoImg = styled.img<{
  $isCondensed: boolean;
  $size?: number;
  $isDisabled?: boolean;
}>`
  ${sharedSizeStyles};
  border-radius: 24px;
  background-color: ${({ $isDisabled }) =>
    $isDisabled ? 'var(--icon-soft)' : 'var(--kg-theme)'};
`;

export const LogoFallback = styled.div<{
  $isCondensed: boolean;
  $size?: number;
  $isDisabled?: boolean;
}>`
  ${sharedSizeStyles};
  display: flex;
  ${borderRadius.rFull};
  background-color: ${({ $isDisabled }) =>
    $isDisabled ? 'var(--background-soft)' : 'var(--dark-purple-12)'};
  color: var(--dark-purple-9);
  justify-content: center;
  align-items: center;
  text-transform: capitalize;
  ${({ $isCondensed }) =>
    $isCondensed ? typographyV2.titleXs : typographyV2.titleXL}
`;
